import React from "react";
import PropTypes from "prop-types";

import logo from "assets/img/large-logo.png";
import { MicrodataContext } from "config/contexts";

import styles from "./Microdata.css";

//this component contains all the microdata that isn't on cards in a way that can be tagged up
export default function Microdata({ story }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => {
        return microdata ? (
          <>
            {story.og_description && (
              <meta itemProp="description" content={story.og_description} />
            )}
            {story.primary_section && story.primary_section.name && (
              <meta
                itemProp="articleSection"
                content={story.primary_section.name}
              />
            )}
            {story.first_published && (
              <time
                className={styles.hidden}
                itemProp="dateCreated"
                dateTime={story.first_published}
              />
            )}
            {story.first_published && (
              <time
                className={styles.hidden}
                itemProp="datePublished"
                dateTime={story.first_published}
              />
            )}
            <meta itemProp="mainEntityOfPage" content={story.permalink} />
            <div
              className={styles.hidden}
              itemProp="publisher"
              itemScope
              itemType="http://schema.org/Organization"
            >
              <meta itemProp="name" content="Axios" />
              <div
                itemProp="logo"
                itemScope
                itemType="http://schema.org/ImageObject"
              >
                <meta itemProp="url" content={logo} />
              </div>
            </div>
          </>
        ) : null;
      }}
    </MicrodataContext.Consumer>
  );
}

Microdata.propTypes = {
  story: PropTypes.shape({
    og_description: PropTypes.string,
    primary_section: PropTypes.shape({
      name: PropTypes.string,
    }),
    permalink: PropTypes.string.isRequired,
  }).isRequired,
};
